import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'metadados/entidade');

const marcaActions = {
  listarCliente: { method: 'GET', url: `${basePath}/cliente` },
  listarCarteiraCliente: { method: 'GET', url: `${basePath}/carteira_cliente` },
  listarProduto: { method: 'GET', url: `${basePath}/produto` },
  listarUsuario: { method: 'GET', url: `${basePath}/usuario` },
  listarAcaoTatica: { method: 'GET', url: `${basePath}/acao_tatica` },
  listarPlanejamentoMaterial: { method: 'GET', url: `${basePath}/planejamento-material` },
  listarRelatorio: { method: 'GET', url: `${basePath}/relatorio` },
  listarDivisao: { method: 'GET', url: `${basePath}/divisao` },
  definicaoOrcamento: { method: 'GET', url: `${basePath}/orcamento` },
  definicaoLinhaInvestimento: { method: 'GET', url: `${basePath}/linha_investimento` },
  definicaoCentroCusto: { method: 'GET', url: `${basePath}/ceco` },
  definicaoAcao: { method: 'GET', url: `${basePath}/acao` },
};

export const marcaResource = resource => resource(`${basePath}`, {}, marcaActions);

export default marcaResource;



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/metadado.js